import { connect } from 'react-redux';
import Metadata from '../components/metadata';

const mapStateToProps = function(state) {
	return {
		show_metadata: state.features.metadata,
		allow_comments: state.features.comments
	};
}

const mapDispatchToProps = {}

const MetadataContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Metadata);

export default MetadataContainer;